<template>
  <a-layout>
    <a-layout-sider v-model:collapsed="ctx.data.menuIsCollapse" collapsible theme="dark" width="210">
      <header class="header-logo">
        <div class="header-left">
          <div class="logo-bar" @click="() => $router.push('/store')">
            <img class="logo" src="/static/images/logo2.png" />
            <span v-if="!ctx.data.menuIsCollapse">商户管理后台</span>
          </div>
        </div>
      </header>
      <div :class="ctx.data.menuIsCollapse ? 'aminui-side isCollapse' : 'aminui-side'">
        <div class="adminui-side-scroll">
          <a-menu theme="dark" mode="inline" v-model:selectedKeys="ctx.data.selectedKeys">
            <nav-menu :menus="ctx.menus.value" />
          </a-menu>
        </div>
      </div>
    </a-layout-sider>
    <a-layout>
      <div class="huasky-header">
        <div class="header-left" style="padding-left: 0px;">
          <topbar />
        </div>
        <div class="header-right">

          <!-- <huasky-icon icon="BellOutlined" class="icon" /> -->
          <span>{{ $app.staff?.name }}</span>
          <a-divider type="vertical" style="height: 20px; background-color: #eee" />
          <userbar />
        </div>
      </div>
      <tags />
      <a-layout-content id="container" class="main-content-wrapper">
        <div class="adminui-main">
          <router-view v-slot="{ Component }" v-if="show">
            <keep-alive :exclude="ctx.tagStore.exclude">
              <component :is="Component" :key="$route.fullPath" />
            </keep-alive>
          </router-view>
          <div class="main-bottom-wrapper">
            2025@版权所有
          </div>
        </div>
      </a-layout-content>
    </a-layout>
  </a-layout>
  <a-back-top :target="onScrollTarget" :visibilityHeight="150"/>
</template>
<script setup lang="ts">
import MainContext from './scripts/main'
import NavMenu from './widgets/NavMenu.vue'
import Topbar from './widgets/Topbar.vue'
import Userbar from './widgets/Userbar.vue'
import Tags from './widgets/Tags.vue'
import { onBeforeMount, ref } from 'vue'
import { getBasicData, logout } from '@src/scripts/system'

const ctx = new MainContext()
ctx.provide()

const show = ref(false)     // 定义字段，通过路由视图的隐藏与显示，控制视图组件的加载

onBeforeMount(async () => {
  // 组件加载之前，加载基础数据
  const result = await getBasicData()
  // 如果基础数据加载失败，则退出登录
  if (!result) {
    logout()
    return
  }
  show.value = true         // 当基础数据加载完成之后，才显示路由视图
  ctx.init()
})

const onScrollTarget = () => {
  return document.querySelector('#container')
}

</script>

<style scoped lang="less">
.huasky-header {
  height: 50px;
  min-height: 50px;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #fff;
  box-shadow: 0 1px 4px rgba(0, 21, 41, .08);
  background-color: #fff;
  border-bottom: 1px solid #ececec;
}

.header-logo {
  height: 50px;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid rgba(255, 255, 255, 0.04);
}

.header-logo-primary-color {
  color: white;
}

.header-logo .logo-bar {
  font-weight: bold;
  display: flex;
  align-items: center;
  font-size: 20px;
  color: white;

  span {
    white-space: nowrap;
  }
  &:hover {
    cursor: pointer;
  }
}

.header-logo .logo-bar .logo {
  margin-right: 10px;
  width: 35px;
  height: 35px;
  border-radius: 8px;
}

.header-left {
  display: flex;
  align-items: center;
  padding-left: 20px;
}

.header-left .menu-unfold-outlined {
  padding: 0 12px
}

.header-right {
  display: flex;
  align-items: center;
  margin-right: 8px;
}

.adminui-main {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: calc(100vh - 120px);
}

.main-content-wrapper {
  padding: 11px 11px 0px;
  overflow-y: auto;
  overflow-x: hidden;
}

.main-bottom-wrapper {
  height: 30px;
  text-align: center;
  flex: auto;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  padding-bottom: 5px;
  color: rgb(160, 160, 160);
}

.ant-menu.ant-menu-dark,
.ant-menu-dark .ant-menu-sub,
.ant-menu.ant-menu-dark .ant-menu-sub {
  color: #ffffffa6;
  background: #001529;
}

.icon {
  font-size: 1.2em;
  color: #999;
  padding: 16px;

  &:hover {
    background-color: #ebebeb;
    cursor: pointer;
  }
}

.aminui-side {
  overflow-y: auto;
  height: 100%;
}
</style>